import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { customersByUsageTierIdAndNextReplenishAt } from "../graphql/queries";
import { CustomersByUsageTierIdAndNextReplenishAtQuery } from "../API";

export async function isUsageTierInUse(tierId: string): Promise<boolean> {
  let nextToken: string | null | undefined = undefined;

  do {
    const res = (await API.graphql(
      graphqlOperation(customersByUsageTierIdAndNextReplenishAt, {
        usageTierId: tierId,
        limit: 100,
        nextToken,
      })
    )) as GraphQLResult<CustomersByUsageTierIdAndNextReplenishAtQuery>;

    const items =
      res.data?.customersByUsageTierIdAndNextReplenishAt?.items || [];
    if (items?.some(Boolean)) return true;
    nextToken = res.data?.customersByUsageTierIdAndNextReplenishAt?.nextToken;
  } while (nextToken);

  return false;
}
